import { Component } from '@angular/core';
import { NotificationType } from '../../../notification/modeles/notification-type';
import { ToolPreautorisationService } from '../../../tool-preautorisation/tool-preautorisation.service';
import { TypeProjet } from '../../constants/type-projet.enum';
import { Store } from '@ngxs/store';
import { AddNotificationDebug } from '../../../notification/notification.state';
import { ToolCapaciteService } from '../../../tool-capacite/tool-capacite.service';

@Component({
  selector: 'app-debug-menu-dsd',
  templateUrl: './debug-menu.component.html',
  styleUrls: ['./debug-menu.component.scss'],
  standalone: false
})
export class DebugMenuComponent {
  isMenuOpened = false;
  notificationType = NotificationType;
  preautorisationDebugComponent = this.toolPreautorisationService.debugComponent;
  capaciteDebugComponent = this.toolCapaciteService.debugComponent;

  notificationTypeKeys = Object.keys(NotificationType);

  constructor(
    private readonly store: Store,
    private readonly toolPreautorisationService: ToolPreautorisationService,
    private readonly toolCapaciteService: ToolCapaciteService
  ) {}

  changeTypeProjet(projet: TypeProjet, visuel?: string) {
    const params = new URLSearchParams();
    if (projet) params.append('projet', projet);
    if (visuel) params.append('visuel', visuel);

    window.location.search = params.toString();
  }

  addNotification(notificationType: NotificationType) {
    this.store.dispatch(new AddNotificationDebug(notificationType));
  }
}
